import axios from 'axios';

const updateLicense = ({ id, ...params }) => {
  return axios.put(`owner/licenses/${id}`, params);
};

export { updateLicense };
